import { $api } from "@/kibi/core/utils/api";
import type { InjectionKey } from "vue";
import type {
  CreatePartnershipRequest,
  PartnershipDTO,
} from "../models/partnership_model";

export interface PartnershipDataSource {
  getPartnerships(): Promise<PartnershipDTO[]>;
  requestPartnership(
    request: CreatePartnershipRequest,
  ): Promise<PartnershipDTO>;
  revokePartnership(id: string): Promise<PartnershipDTO>;
  approvePartnership(id: string): Promise<PartnershipDTO>;
  resendPartnership(id: string): Promise<PartnershipDTO>;
  deletePartnership(id: string): Promise<void>;
}

export const partnershipDataSourceKey: InjectionKey<PartnershipDataSource> =
  Symbol("PartnershipDataSource");

export class PartnershipDataSourceImpl implements PartnershipDataSource {
  async getPartnerships(): Promise<PartnershipDTO[]> {
    const response = await $api<{ data: PartnershipDTO[] }>(
      "/accounts/partnerships",
      {
        method: "GET",
      },
    );
    return response.data;
  }

  async requestPartnership(
    request: CreatePartnershipRequest,
  ): Promise<PartnershipDTO> {
    const response = await $api<{ data: PartnershipDTO }>(
      "/accounts/partnerships",
      {
        method: "POST",
        body: request,
      },
    );
    return response.data;
  }

  async revokePartnership(id: string): Promise<PartnershipDTO> {
    const response = await $api<{ data: PartnershipDTO }>(
      `/accounts/partnerships/${id}/revoke`,
      {
        method: "PUT",
      },
    );
    return response.data;
  }

  async approvePartnership(id: string): Promise<PartnershipDTO> {
    const response = await $api<{ data: PartnershipDTO }>(
      `/accounts/partnerships/${id}/approve`,
      {
        method: "POST",
      },
    );
    return response.data;
  }

  async resendPartnership(id: string): Promise<PartnershipDTO> {
    const response = await $api<{ data: PartnershipDTO }>(
      `/accounts/partnerships/${id}/resend`,
      {
        method: "POST",
      },
    );
    return response.data;
  }

  async deletePartnership(id: string): Promise<void> {
    await $api(`/accounts/partnerships/${id}`, {
      method: "DELETE",
    });
  }
}
